
import React from "react";
import {Action, DashboardContainer } from "../../funcs/utils";
import { Spinner } from "../../funcs/utils";
import { timestamp_to_time_str } from "../../../lib/time";
import {getRGB} from "../../../lib/color";
import {MessagePopup} from "./MessagePopup";
import { ComposePopup } from "./ComposePopup";
import {SUPER_ADMIN} from "../../../lib/constants";

class InboxDashboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      is_composing: false,
      subject: "",
      text: "",
      is_loading: false,
      mouse_over_id: "",
      show_message: "",
    }
  }

  componentDidMount = () => {
    if (this.props.inbox.messages.length === 0) {
      this.props.emailLoadInbox();
    }
  }


  onCompose = () => {
    this.setState({
      is_composing: true,
    })
  };

  onMouseOver = (id, over) => ev => {
    if (over) {
      this.setState({ mouse_over_id: id});
    } else {
      this.setState({ mouse_over_id: ""});
    }
  }

  onMsgClick = id => ev => {
    this.setState({show_message: id});
    this.props.markMessageRead(id);
  }

  renderMessages = () => {
    if (this.props.inbox.loading) {
      return (
        <div align={"center"}>
          <Spinner size={"2rem"}/>
        </div>
      );
    }

    const today = new Date();

    const render_msg = (msg, index) => {
      const container_style = {
        display: "flex",
        alignItems: "center",
        margin: "1rem",
        border: "1px solid white",
        cursor:  "pointer",
      }
      const read_button_style = {
        width: "1.5rem",
        height: "1.5rem",
        border: "1px solid black",
        flex: "0 0 1.5rem",
        margin: "0.5rem",
      }
      if (msg.id === this.state.mouse_over_id) {
        container_style.border = "1px solid black";
      }
      if (!msg.read) {
        read_button_style.backgroundColor = getRGB(this.props.client.color.sign_on_button);
      }

      const msg_date = new Date(msg.timestamp_ms);
      const sent_today = msg_date.getDate() === today.getDate()
        && msg_date.getMonth() === today.getMonth()
        && msg_date.getYear() === today.getYear();
      const time_label = sent_today
        ? timestamp_to_time_str(msg_date) : msg_date.toDateString();

      return (
        <div
          key={index}
          onMouseEnter={this.onMouseOver(msg.id, true)}
          onMouseLeave={this.onMouseOver(msg.id, false)}
          onClick={this.onMsgClick(msg.id)}
          style={container_style}>
          <div style={read_button_style}/>
          { /* from_div */ }
          { /* to_div */ }
          <div style={{flex: "1"}}>
            <span>{msg.subject}</span>
          </div>
          <div style={{flex: "0 0 8rem"}}>
            { time_label }
          </div>
        </div>
      )
    }
    return (
      <div>
        { this.props.inbox.messages.map(render_msg) }
      </div>
    )
  }

  maybeRenderMessage = () => {
    if (!this.state.show_message) {
      return null;
    }

    const on_close = () => {
      this.setState({ show_message: "" });
    }
    const msg = this.props.inbox.messages.find(
      msg => msg.id === this.state.show_message);

    if (msg) {
      return (
        <MessagePopup
          username={this.props.user.username}
          onClose={on_close}
          message={msg}
        />
      )
    }
    return null;
  }

  onComposeCancel = () => {
    this.setState({
      is_composing: false,
    })
  };

  onSend = () => {
    this.setState({
      is_composing: false,
    })
    this.props.sendMessage(
      this.props.user.username,
      SUPER_ADMIN,
      this.state.subject,
      this.state.text);

  };

  render = () => {

    const compose =
      (this.state.is_composing || this.props.inbox.sending )
        ? (<ComposePopup
            to={"support@cleveralpha.com"}
            on_cancel={this.onComposeCancel}
            on_send={this.onSend}
            component={this}/>
        ) : null;

    return (
      <DashboardContainer
        title={"Email"}
        client={this.props.client}>
        <div>
          <Action onClick={this.onCompose}>
            Compose
          </Action>
          <div style={{marginTop: "2rem"}}>
            { this.renderMessages() }
          </div>
          <div>
            { compose }
            { this.maybeRenderMessage() }
          </div>
        </div>
      </DashboardContainer>
    )
  }
}

export { InboxDashboard };
